import { t } from "i18next";
import { DirectUploadMedia } from "libs/directUpload";
import * as yup from "yup";

export const contentVideoSchema = yup.object({
  id: yup.string().nullable(),
  title: yup
    .string()
    .required(t("The title field is requited"))
    .min(5, t("The title field should contain at least 5 characters."))
    .max(50, t("The title field cannot exceed 50 characters.")),
  description: yup
    .string()
    .required(t("The description field  is requited"))
    .min(10, t("The description field should contain at least 10 characters."))
    .max(200, t("The description field cannot exceed 200 characters.")),
  video: yup
    .mixed<DirectUploadMedia>()
    .required()
    .nullable()
    .test(
      "is-null",
      t("The video field is required"),
      (fieldValue) => !!fieldValue
    ),
  thumbnail: yup
    .mixed<DirectUploadMedia>()
    .required()
    .nullable()
    .test(
      "is-null",
      t("The thumbnail field is required"),
      (fieldValue) => !!fieldValue
    )
});
